// extracted by mini-css-extract-plugin
export default {"base":"no-results_base__2Ac+x","text":"no-results_text__c5ReB"};